import { useCallback, useState } from 'react';
import { useQuery } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { ALL_OPTION_KEY } from '@/common/constants';
import { API_URL } from '@/dtos';

import { useDownloadCSV, useGetEmployerIdParam } from '../../hooks';
import { PayrollContributionSummaryReportParams } from '../PayrollContributionReport.types';

export const QUERY_KEY = 'EXPORT_PAYROLL_CONTRIBUTION_REPORT_CSV';
const usePayrollContributionReportExportSummaryCSVQuery = (
  params: PayrollContributionSummaryReportParams
) => {
  const getEmployerIdParam = useGetEmployerIdParam();
  const handleSaveFile = useDownloadCSV();
  const [isLoading, setIsLoading] = useState(false);
  const { refetch } = useQuery(
    [QUERY_KEY],
    () =>
      api.get(
        params?.isMultipleEmployer
          ? API_URL.REPORTS_PAYROLL_CONTRIBUTIONS_REPORT_MULTI_EMPLOYERS_SUMMARY_EXPORT_CSV
          : API_URL.REPORTS_PAYROLL_CONTRIBUTIONS_REPORT_SUMMARY_EXPORT_CSV,
        {
          params: _.pickBy({
            ...getEmployerIdParam(params.employerId, params.employerIds),
            plan_year_period:
              params?.planYearPeriod && !params?.planYearPeriod.includes(ALL_OPTION_KEY)
                ? params?.planYearPeriod.join(',')
                : undefined,
            plan_ids:
              params?.planIds && !params?.planIds.includes(ALL_OPTION_KEY)
                ? params?.planIds.join(',')
                : undefined,
          }),
        }
      ),
    {
      retry: 0,
      enabled: false,
    }
  );

  const handleExport = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await refetch();
      handleSaveFile(response.data?.data, 'csv', 'payroll_contribution_summary');
    } finally {
      setIsLoading(false);
    }
  }, [handleSaveFile, refetch]);
  return {
    isLoading,
    handleExport,
  };
};

export default usePayrollContributionReportExportSummaryCSVQuery;
